<template>
  <div class="container">
    <div class="tabs">
      <div
        class="tab-item"
        :class="[currTab == 1 ? 'active' : '']"
        @click="onTabClick(1)"
      >
        Account Details
      </div>
      <div
        class="tab-item"
        :class="[currTab == 2 ? 'active' : '']"
        @click="onTabClick(2)"
      >
        Address Book
      </div>
    </div>
    <div class="margin-top-30" v-show="currTab == 1">
      <div class="flex">
        <div class="panel">
          <h2>Personal information</h2>
          <div class="form">
            <div class="flex align-center">
              <div class="form-group margin-right-10" style="width: 100px">
                <div class="form-label">Title</div>
                <Select
                  v-model="form_data1.sex"
                  style="width: 100px; height: 40px"
                >
                  <Option :value="1">Ms</Option>
                  <Option :value="2">Mr</Option>
                </Select>
              </div>

              <div class="form-group margin-right-10" style="width: 225px">
                <div class="form-label">First name</div>
                <input
                  type="text"
                  class="input"
                  v-model="form_data1.nickname"
                />
              </div>
              <div class="form-group margin-right-10" style="width: 225px">
                <div class="form-label">Last name</div>
                <input
                  type="text"
                  class="input"
                  v-model="form_data1.realname"
                />
              </div>
            </div>

            <div class="form-group">
              <div class="form-label">Date of birth (Optional)</div>
              <div class="form-control">
                <Date-picker
                  @on-change="handleChange"
                  type="date"
                  placeholder="MM-DD-YYYY"
                  format="MM-dd-yyyy"
                  v-model="form_data1.birthday"
                  style="width: 200px"
                ></Date-picker>
              </div>
            </div>
            <div class="btn-submit" @click="save1">Update</div>
          </div>
        </div>
        <div class="avatar-wrap">
          <Upload
            :action="upload_url"
            :data="{ dir: 'template' }"
            :show-upload-list="false"
            :on-success="handleSuccess"
            class="avatar-upload"
          >
            <img class="avatar" :src="form_data1.avatar | default_img" alt="" />
            <img
              class="avatar-edit"
              src="../../assets/images/user/icon_edit_avatar.png"
            />
          </Upload>
          <div class="tips">Change profile photo</div>
        </div>
      </div>
      <div class="panel">
        <h2>Password</h2>
        <div class="form">
          <div class="form-group">
            <div class="form-label">Password:</div>
            <div class="form-control" style="width: 341px">
              <input
                type="text"
                class="input"
                placeholder="New Password"
                v-model="form_data2.password"
              />
            </div>
          </div>
          <div class="form-group">
            <div class="form-label">Re-enter Password:</div>
            <div class="form-control" style="width: 341px">
              <input
                type="text"
                class="input"
                placeholder="Re-enter Password"
                v-model="form_data2.confirm_password"
              />
            </div>
          </div>

          <div class="btn-submit" @click="save2">Update password</div>
        </div>
      </div>
    </div>
    <div class="margin-top-30" v-show="currTab == 2">
      <template v-if="address_list.length > 0">
        <div class="flex align-center justify-between">
          <h2>My shipping address</h2>
          <div
            class="add-address-box flex align-center justify-between"
            @click="is_popup_show = true"
          >
            <img src="../../assets/images//user/icon-balck-plus.png" />
            <span class="text-black">Add an address</span>
          </div>
        </div>
        <div class="flex flex-wrap justify-between margin-top-30">
          <div
            class="address-box"
            v-for="(item, index) in address_list"
            :key="index"
          >
            <div class="top-box">
              <img
                src="../../assets/images/user/icon_address.png"
                class="icon-location"
              />
              <div class="flex align-center justify-between">
                <div class="address-content">
                  <div>
                    {{ item.title }} {{ item.first_name }}{{ item.last_name }}
                  </div>
                  <div>
                    {{ item.address }} {{ item.address_alternate }},{{
                      item.city
                    }},{{ item.state }},{{ item.zip_code }}
                  </div>
                  <div>{{ item.country }}</div>
                </div>
                <div class="text-black margin-right-20">
                  <div class="">Phone number</div>
                  <div class="margin-top-10">{{ item.phone }}</div>
                </div>
              </div>
            </div>
            <div class="bottom-box flex align-center justify-between">
              <div class="flex align-center">
                <label @click="edit_address(item)" class="flex align-center margin-right-20">
                <img
                  src="../../assets/images/user/address-edit-icon.png"
                  class="icon"
                />
                <span class="margin-right-20">Edit</span>
                </label>
                
                <label @click="del(item.id)" class="flex align-center">
                  <img
                  src="../../assets/images/user/address-delete-icon.png"
                  class="icon"
                />
                <span>Delete</span>
                </label>
                
              </div>
              <div class="flex align-center" @click="set_default(item)">
                <input type="checkbox" readonly :checked="item.is_default" />
                <span class="margin-left-5"> Default Address</span>
              </div>
            </div>
          </div>
        </div>
      </template>
      <template v-if="address_list.length == 0">
        <div class="empty-address">
          <img
            class="empty-icon"
            src="../../assets/images/user/address-empty.png"
          />
          <div class="margin-top-20 tip1">
            You don’t have any saved addresses
          </div>
          <div class="margin-top-20 tip2">
            Add address for convenient and faster customization of clothing
          </div>
          <div
            class="add-address-box flex align-center justify-between margin-top-30"
            @click="is_popup_show = true"
          >
            <img src="../../assets/images//user/icon-balck-plus.png" />
            <span class="text-black">Add an address</span>
          </div>
        </div>
      </template>
    </div>
    <popup
      :show.sync="is_popup_show"
      width="560px"
      height="850px"
      class="bg-white"
      @on-close="close"
    >
     
       <h2>{{ form_address_data.id ? "Edit Shipping Address" : "Add Shipping Address" }}</h2>
      <Form
        class="address-form"
        ref="formValidate"
        :model="form_address_data"
        :rules="rules"
      >
        <div class="form-group">
          <FormItem prop="country" label="Country/region">
            <Select
              v-model="form_address_data.country"
              filterable
              style="height: 40px"
            >
              <Option
                :value="item.name"
                :key="index"
                v-for="(item, index) in countryList"
                >{{ item.name }}</Option
              >
            </Select>
          </FormItem>
        </div>

        <div class="form-group">
          <FormItem prop="title" label="Title (optional)" style="width: 245px">
            <Select v-model="form_address_data.title" style="height: 40px">
              <Option value="Mr">Mr</Option>
              <Option value="Mrs">Mrs</Option>
              <Option value="Mrs">Miss</Option>
              <Option value="Ms">Ms</Option>
              <Option value="Ms">Sir</Option>
            </Select>
          </FormItem>
        </div>
        <div class="form-group">
          <div class="flex align-center justify-between">
            <FormItem prop="first_name" label="First name">
              <Input
                type="text"
                class="input"
                v-model="form_address_data.first_name"
                style="width: 245px"
              />
            </FormItem>
            <FormItem prop="last_name" label="Last name">
              <Input
                type="text"
                class="input"
                v-model="form_address_data.last_name"
                style="width: 245px"
              />
            </FormItem>
          </div>
        </div>
        <div class="form-group">
          <FormItem prop="address" label="Address line one">
            <Input
              type="text"
              class="input"
              v-model="form_address_data.address"
            />
          </FormItem>
        </div>
        <div class="form-group">
          <FormItem
            prop="address_alternate"
            label="Address line two (optional)"
          >
            <Input
              type="text"
              class="input"
              v-model="form_address_data.address_alternate"
            />
          </FormItem>
        </div>
        <div class="form-group">
          <FormItem prop="city" label="City">
            <Input type="text" class="input" v-model="form_address_data.city" />
          </FormItem>
        </div>

        <div class="form-group">
          <div class="flex align-center justify-between">
            <FormItem prop="state" label="State" style="width: 245px">
              <Select v-model="form_address_data.state" style="height: 40px">
                <Option
                  :value="item.name"
                  :key="index"
                  v-for="(item, index) in stateList"
                  >{{ item.name }}</Option
                >
              </Select>
            </FormItem>

            <FormItem prop="zip_code" label="ZIP code" style="width: 245px">
              <Input
                type="text"
                class="input"
                v-model="form_address_data.zip_code"
              />
            </FormItem>
          </div>
        </div>
        <div class="form-group">
          <div class="flex align-center justify-between">
            <FormItem prop="phone" label="Phone number">
              <Input
                type="text"
                class="input"
                v-model="form_address_data.phone"
                style="width: 245px"
              />
            </FormItem>
            <FormItem
              prop="phone_alternate"
              label="Alternate number (optional)"
            >
              <Input
                type="text"
                class="input"
                v-model="form_address_data.phone_alternate"
                style="width: 245px"
              />
            </FormItem>
          </div>
        </div>
        <div class="flex align-center justify-center">
          <Button class="btn-submit" @click="saveAddress('formValidate')"
            >Save</Button
          >
        </div>
      </Form>
    </popup>
  </div>
</template>

<script>
import axios from "axios";
import region from "@/utils/region.js";
import { Profile } from "@/api/index.js";
import {
  SaveProfile,
  RevisePassword,
  AddressList,
  GetAddress,
  SaveAddress,
  DeleteAddress,
  SetDefaultAddress,
  GetRegionList,
} from "../../api";
import Popup from "@/components/Popup.vue";


export default {
  name: "UserCenter",
  components: {
    Popup,
  },
  data() {
    return {
      upload_url: process.uniEnv.BASE_API + "/util/upload-image",
      value: [],
      region: region,
      form_data1: {
        username: "",
        mobile: "",
        nickname: "",
        realname: "",
        sex: 1,
        birthday: "",
        province: "",
        city: "",
        zone: "",
        create_time: "",
      },
      form_data2: {
        password: "",
        confirm_password: "",
      },
      currTab: 1,
      address_list: [],
      is_popup_show: false,
      form_address_data: {
        id: 0,
        country: "",
        title: "",
        first_name: "",
        last_name: "",
        state: "",
        address: "",
        address_alternate: "",
        city: "",
        zip_code: "",
        phone: "",
        phone_alternate: "",
        is_default: 0,
      },
      rules: {
        country: [
          {
            required: true,
            message: "Country/region is required",
            trigger: "change",
          },
        ],
        first_name: [
          {
            required: true,
            message: "First name is required",
            trigger: "blur",
          },
        ],
        last_name: [
          {
            required: true,
            message: "Last name is required",
            trigger: "blur",
          },
        ],
        address: [
          {
            required: true,
            message: "Address line one is required",
            trigger: "blur",
          },
        ],
        city: [
          {
            required: true,
            message: "City is required",
            trigger: "blur",
          },
        ],
        zip_code: [
          {
            required: true,
            message: "ZIP code is required",
            trigger: "blur",
          },
        ],
        state: [
          {
            required: true,
            message: "State is required",
            trigger: "blur",
          },
        ],
        phone: [
          {
            required: true,
            message: "Phone number is required",
            trigger: "blur",
          },
        ],
      },
      countryList: [],
      stateList: [],
    };
  },
  mounted() {
    axios.all([this.getProfile()]).then(axios.spread((response1) => {}));
    this.getList();
    this.getCountryList();
  },
  watch: {
    "form_address_data.country": function (e) {
      this.getStateList();
    },
  },
  methods: {
    onTabClick(type) {
      this.currTab = type;
    },
    handleSuccess(response, file, fileList) {
      this.form_data1.avatar = response.data.url;
      SaveProfile(this.form_data1)
        .then(() => {
          this.$layer.msg(`Success`);
        })
        .finally(() => {
          this.getProfile();
        });
    },
    choose_sex(sex) {
      this.form_data1.sex = sex;
    },
    handleChange(e) {
      console.log(e);
      this.form_data1.birthday = e;
      
    },
    save1() {
     
      SaveProfile(this.form_data1)
        .then(() => {
          this.$layer.msg(`Success`);
        })
        .finally(() => {
          this.getProfile();
        });
    },
    save2() {
      if (!this.form_data2.password) {
        this.$layer.msg("Enter Password");
        return;
      }
      if (!this.form_data2.confirm_password) {
        this.$layer.msg("Re-enter Password");
        return;
      }
      if (this.form_data2.password != this.form_data2.confirm_password) {
        this.$layer.msg("Password inconsistency");
        return;
      }
      RevisePassword(this.form_data2)
        .then(() => {
          this.$layer.msg(`Success`);
        })
        .finally(() => {
          this.getProfile();
          this.form_data2.password = this.form_data2.confirm_password = "";
        });
    },
    close() {
      this.is_popup_show = false;
    },
    edit_address(item) {
				this.form_address_data = item
				this.is_popup_show = true
			},
			del(id) {
				this.$DModal.confirm({
					content: 'Are you sure you want to delete this address information',
          	okText: 'Confirm',
                    cancelText: 'Cancel',
					onOK: () => {
						DeleteAddress({id}).then(() => {
							this.$layer.msg(`Success`)
						}).finally(() => {
							this.getList()
						})
					}
				})
			},
			set_default(address) {
        if(address.is_default) {
					return
				}
				SetDefaultAddress({id: address.id}).then(response => {
					this.$layer.msg(`Success`)
					this.getList()
				})
			},
    saveAddress(name) {
      this.$refs[name].validate((valid) => {
        if (valid) {
          SaveAddress(this.form_address_data)
            .then(() => {
              this.$layer.msg(`Success`);
              this.$refs[name].resetFields();
              this.is_popup_show = false;
            })
            .finally(() => {
              this.getList();
            });
        }
      });
    },
    async getProfile() {
      return Profile().then((response) => {
        this.$store.commit("setUserInfo", this.$_.cloneDeep(response.data));
        this.form_data1 = response.data;
        this.value = [
          this.form_data1.province,
          this.form_data1.city,
          this.form_data1.zone,
        ];
        return response;
      });
    },
    async getList() {
      AddressList().then((response) => {
        this.address_list = response.data;
      });
    },
    async getCountryList() {
      GetRegionList().then((res) => {
        this.countryList = res.data;
      });
    },
    async getStateList() {
      let country = this.countryList.find(
        (i) => i.name == this.form_address_data.country
      );
      if (!country) {
        return;
      }
      GetRegionList({
        parent_id: country.country_id,
        type: 1,
      }).then((res) => {
        this.stateList = res.data;
      });
    },
  },
};
</script>

<style lang="scss" scoped>
.container {
  padding: 20px 100px 180px 30px;
  .tabs {
    display: flex;
    justify-content: flex-start;
    align-items: center;
    border-bottom: 1px solid #d6d6d6;
    padding-bottom: 20px;
    .tab-item {
      cursor: pointer;
      color: #666666;
      font-size: 18px;
      margin-right: 50px;
      position: relative;
      z-index: 2;

      &.active {
        color: #000000;
        font-weight: bold;

        &::after {
          content: "";
          position: absolute;
          left: 0;
          bottom: -20px;
          width: 100%;
          height: 3px;
          background: #000000;
          z-index: 3;
          pointer-events: none;
        }
      }
    }

    .tab-item.active {
      border-bottom: none !important;
    }
  }
  .avatar-wrap {
    flex: 1;
    display: flex;
    flex-direction: column;
    align-items: center;
    .avatar-upload {
      position: relative;
      width: 160px;
      height: 160px;
    }
    .avatar {
      width: 160px;
      height: 160px;
      border-radius: 50%;
    }

    .avatar-edit {
      width: 42px;
      height: 42px;
      position: absolute;
      left: 59px;
      bottom: -21px;
    }
    .tips {
      margin-top: 30px;
      font-size: 14px;
      color: #666666;
    }
  }
  h2 {
    font-size: 20px;
    color: #212121;
    font-weight: bold;
  }
  .panel {
    margin-bottom: 20px;
    padding: 30px 40px;
    background: #ffffff;
    border-radius: 2px 2px 2px 2px;
    border: 1px solid #cbcbcb;
    width: 50vw;

    .form {
      .form-group {
        margin-top: 20px;
        .form-label {
          font-size: 14px;
          color: #212121;
          text-align: left;
          margin-bottom: 5px;
        }
        .input {
          width: 100%;
          height: 40px;
          line-height: 40px;
          padding: 0 10px;
          outline: none;
          background: #ffffff;
          border-radius: 2px;
          border: 1px solid #cbcbcb;
          &[readonly] {
            border: none;
          }
        }
      }

      .btn-submit {
        margin: 40px 0 0 0px;
        width: 220px;
        height: 40px;
        line-height: 40px;
        background: #0d0c22;
        border-radius: 2px;
        font-size: 14px;
        color: #ffffff;
        text-align: center;
        cursor: pointer;
      }
    }
  }
}

::v-deep .ivu-input {
  height: 40px;
  line-height: 40px;
  border: 1px solid #e3e3e3;
  border-radius: 10px;
  padding: 0 10px;
  outline: none;
}
::v-deep .ivu-select-selection {
  height: 40px;
  line-height: 40px;
}
::v-deep .ivu-select-single .ivu-select-selection .ivu-select-placeholder {
  height: 40px;
  line-height: 40px;
}
::v-deep .ivu-select-single .ivu-select-selection .ivu-select-selected-value {
  height: 40px;
  line-height: 40px;
}
.add-address-box {
  height: 40px;
  background: #ffffff;
  border-radius: 2px 2px 2px 2px;
  border: 1px solid #999999;
  padding: 0 16px;
  cursor: pointer;

  img {
    width: 15px;
    height: 15px;
    margin-right: 5px;
  }
}
.empty-address {
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  margin-top: 130px;
  .tip1 {
    font-size: 22px;
    color: #212121;
  }
  .tip2 {
    font-size: 14px;
    color: #212121;
  }
  .empty-icon {
    width: 57px;
    height: 57px;
  }
}
.address-form {
  padding: 30px 20px;
  .form-group {
    margin-bottom: 20px;
    ::v-deep .ivu-form-item-label {
      font-size: 14px;
      color: #212121;
      padding: 0px;
      margin-bottom: 5px;
    }
    ::v-deep .ivu-input {
      border-radius: 2px;
    }
    .input {
      //   width: 100%;
      //   height: 40px;
      //   line-height: 40px;
      //   padding: 0 10px;
      //   outline: none;
      //   background: #ffffff;
      border-radius: 2px;
      //   border: 1px solid #cbcbcb;
    }
  }
  .btn-submit {
    width: 220px;
    height: 40px;
    background: #0d0c22;
    border-radius: 2px;
    font-size: 14px;
    color: #ffffff;
    text-align: center;
    cursor: pointer;
  }
}

.address-box {
  width: 49%;
  background: #fafafa;
  border-radius: 5px 5px 5px 5px;
  border: 1px solid #e0e0e0;
    margin-bottom: 20px;
  .icon-location {
    width: 26px;
    height: 26px;
  }
  .top-box {
    padding: 20px;
    border-bottom: 1px solid #e0e0e0;
    .address-content {
      font-size: 14px;
      color: #000000;
      line-height: 24px;
    }
  }
  .bottom-box {
    padding: 16px 20px;
    font-size: 14px;
    color: #4d4d4d;
    cursor: pointer;
    .icon {
      width: 20px;
      height: 20px;
      margin-right: 2px;
    }
  }
}
</style>
